<div class="repo-contact-org-popup">
  <div class="modal-header">
    <h5 class="modal-title" id="permissionModalLabel">Contacts - {{business.businessName}}</h5>
    <button type="button"
            *ngIf="isViewMode"
            class="btn-close"
            aria-label="Close"
            (click)="dismissPopup()"></button>
    <div class="d-flex justify-content-end ms-auto" *ngIf="!isViewMode">
      <button type="button" class="btn col-auto me-2 btn-secondary" (click)="cancelPopup()"><i class="fa fa-times"></i> Cancel</button>
      <button type="button" class="btn col-auto btn-primary" (click)="saveContact()"><i class="fa fa-save"></i> Save</button>
    </div>

  </div>
  <div class="modal-body" *ngIf="!isViewMode">
    <app-repocontact-edit #repoContactEdit [(contact)]="contact" [isUSA]="isUSA"  (contactSaved)="contactSaved($event)"  (contactValidationFailed)="contactValidationFailed($event)"></app-repocontact-edit>
  </div>
  <div class="modal-body" *ngIf="isViewMode">
    <div class="row g-2 mb-2  justify-content-end">
      <div class="col-auto">
        <div class="custom-search-section">
          <input type="text"
                 name="somethingAutofillDoesntKnowAbout"
                 autocomplete="new-password"
                 class="form-control search-input"
                 id="search"
                 [(ngModel)]="searchTerm"
                 placeholder="Search…" />
        </div>
      </div>
      <div class="col-auto">
        <div class="flex justify-content-end">
          <button class="btn btn-primary btn-sm ms-2"
                  type="button"
                  (click)="AddContact()">
            <i class="fa fa-plus"></i> Add Contact
          </button>
        </div>
      </div>
    </div>
    <div class="table-scroll table-responsive data-grid" #tableContact>
      <app-repocontact-list (editRepoContact)="EditRepoContact($event)" [tableContact]="tableContact" [(searchTerm)]="searchTerm" [(contacts)]="contacts" [selectedBusinessId]="business?.repoBusinessId"></app-repocontact-list>
    </div>
  </div>
</div>
